import React from 'react'
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import ForecastStatContainer from '../../containers/forecaststat/ForecastStatContainer';

const ForecastStatViewPage = () => {
    return (
        <div>
            <BreadcrumbsContainer title="포캐스팅 관리/포캐스팅 통계/부서별 통계" icon="chance" />
            <ForecastStatContainer />
        </div>
    )
}

export default ForecastStatViewPage